// extracted by mini-css-extract-plugin
export var image = "_ir-0";